module.exports = '8a3c8fdf32b621260b2ff02086ab278c.png'


//////////////////
// WEBPACK FOOTER
// ./client/assets/sprites.svg
// module id = 21
// module chunks = 0